import React from 'react'
import Pictorial from './charts/Pictorial'
import { makeStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles({
	cont: {
		maxWidth: 820,
		margin: '2.5em auto 3em',
	}
})

const Desagregado = ({ desagregado }) => {
	const classes = useStyles()
	const matches = useMediaQuery('(max-width:600px)');

	return <div className={classes.cont}>{desagregado && <Pictorial data={desagregado} matches={matches} />}</div>
}

export default Desagregado
